import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IAddressInput } from "@/interfaces/contact.interface";
import contactService from "@/services/contact.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateAdditionalAddressProps = UpdateByIdProps<IAddressInput>;

export type UseUpdateAdditionalAddressReturn = {
  update: (props: UpdateAdditionalAddressProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateAdditionalAddress = (): UseUpdateAdditionalAddressReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IAddressInput>({
    operation: (formData, addressId) => contactService.updateAddress(formData, addressId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateAdditionalAddress;
